import React from 'react'
import {Link} from "react-router-dom"


function BackToService() {
    return (
        <Link className="" title = "Back to service" style={{"marginLeft" : "30px"}} to="/service"><i className="bx bx-undo back-label"></i></Link>
    )
}

export default BackToService
